'use client'
import { useMutation } from '@tanstack/react-query'
import { useCallback } from 'react'
import { INewsletterSubscribeForm } from '@/schemas/pages'
import { subscribeNewsletterService } from '@/services/domain/pages/NewsletterService'

/** Inscrição na newsletter (rodapé). O erro já sai em toast pelo service; a confirmação de sucesso é da tela. */
export function useNewsletterSubscribe() {
    const mutation = useMutation({ mutationFn: subscribeNewsletterService })
    const { mutateAsync } = mutation

    const subscribe = useCallback((data: INewsletterSubscribeForm) => mutateAsync(data), [mutateAsync])

    return { subscribe, isPending: mutation.isPending, isSuccess: mutation.isSuccess, reset: mutation.reset }
}
